export const paymentGateways = {
  name: '支付網關',
  edit_title: '編輯支付網關',
  fields: {
    code: '代碼',
    name: '名稱',
    is_active: '啟用',
    is_configured: '已配置',
    supports_tokenization: '可儲存',
    env_var_prefix: '環境變數前綴',
    config: '配置',
    created_at: '建立時間',
    updated_at: '更新時間',
  },
  status: {
    configured: '已配置',
    not_configured: '未配置',
  },
  sections: {
    basic_settings: '基本設定',
    gateway_info: '網關資訊',
    environment: '環境配置',
  },
  hints: {
    configured: '網關已配置所有必要的環境變數',
    not_configured: '缺少必要的環境變數',
    not_configured_warning: '此網關尚未完全配置。請確認所有必要的環境變數已設定。',
    is_active: '停用後，使用此網關的付款方式將不可用',
    edit_info: '網關設定。敏感配置（API 金鑰、密鑰）必須設定為環境變數。',
    environment_vars: '此網關需要配置以下環境變數：',
    no_env_prefix: '未定義環境變數前綴',
  },
};

export const paymentGatewaysResource = {
  ...paymentGateways,
};
